import { useState } from "react";
import { Plus, Pill } from "lucide-react";
import CustomSelect from "./CustomSelect";

const MedicineSelector = ({ medicineList, onAdd }) => {
  const [selectedMedicine, setSelectedMedicine] = useState(null);
  const [dose, setDose] = useState(null);
  const [indication, setIndication] = useState(null);
  const [dose1, setDose1] = useState(null);
  const [dose2, setDose2] = useState(null);
  const [dose3, setDose3] = useState(null);
  const [dose4, setDose4] = useState(null);
  const [dose5, setDose5] = useState(null);
  const [timing, setTiming] = useState(null);
  const [continueTill, setContinueTill] = useState(null);

  const medicineOptions = medicineList.map((med, index) => ({
    value: index,
    label: `${med[0]} (${med[1]}) - ${med[2]}`,
    data: med,
  }));

  /*
  const dose1Options = [
    "0",
    ".5",
    ".75",
    "1",
    "1.25",
    "1.5",
    "1.75",
    "2",
    "2.5",
  ].map((val) => ({
    value: val,
    label: val,
  }));

  const dose2Options = [
    "0",
    ".5",
    ".75",
    "1",
    "1.25",
    "1.5",
    "1.75",
    "2",
    "2.5",
    "Puff",
    "Spoon",
    "Drop",
    "Ampule",
    "Stick",
  ].map((val) => ({ value: val, label: val }));

  const dose3Options = [
    "0",
    ".5",
    ".75",
    "1",
    "1.25",
    "1.5",
    "1.75",
    "2",
    "2.5",
    "/ Minute",
  ].map((val) => ({ value: val, label: val }));

  const dose4Options = [
    "0",
    ".5",
    ".75",
    "1",
    "1.25",
    "1.5",
    "1.75",
    "2",
    "2.5",
    "Times",
    "Hourly",
  ].map((val) => ({ value: val, label: val }));

  const dose5Options = [
    "Using Respo Chamber",
    "I/M",
    "I/V",
    "P/R",
    "P/V",
    "Left Eye",
    "Both Eye",
  ].map((val) => ({ value: val, label: val }));
  */
  const timingOptions = [
    { value: "Before Meal", label: "Before Meal" },
    { value: "After Meal", label: "After Meal" },
    { value: "1/2 hour before meal", label: "1/2 hour before meal" },
    { value: "1/2 hour after meal", label: "1/2 hour after meal" },
    { value: "1 hour before meal", label: "1 hour before meal" },
    { value: "1 hour after meal", label: "1 hour after meal" },
    { value: "at bed time", label: "at bed time" },
  ];

  const continueOptions = [
    { value: "1 Day", label: "1 Day" },
    { value: "2 Days", label: "2 Days" },
    { value: "3 Days", label: "3 Days" },
    { value: "4 Days", label: "4 Days" },
    { value: "5 Days", label: "5 Days" },
    { value: "6 Days", label: "6 Days" },
    { value: "7 Days", label: "7 Days" },
    { value: "8 Days", label: "8 Days" },
    { value: "9 Days", label: "9 Days" },
    { value: "10 Days", label: "10 Days" },
    { value: "11 Days", label: "11 Days" },
    { value: "12 Days", label: "12 Days" },
    { value: "13 Days", label: "13 Days" },
    { value: "14 Days", label: "14 Days" },
    { value: "15 Days", label: "15 Days" },
    { value: "3 Weeks", label: "3 Weeks" },
    { value: "1 Month", label: "1 Month" },
    { value: "1.5 Months", label: "1.5 Months" },
    { value: "2 Months", label: "2 Months" },
    { value: "3 Months", label: "3 Months" },
    { value: "4 Months", label: "4 Months" },
    { value: "5 Months", label: "5 Months" },
    { value: "6 Months", label: "6 Months" },
    { value: "Continue", label: "Continue" },
  ];

  const handleAdd = () => {
    if (selectedMedicine && dose && timing && continueTill && indication) {
      onAdd({
        name: selectedMedicine.data[0],
        strength: selectedMedicine.data[1],
        type: selectedMedicine.data[2],
        generic_name: selectedMedicine.data[3],
        dosage: dose?.value /* getMedicineDosage([
          dose1?.value || "",
          dose2?.value || "",
          dose3?.value || "",
          dose4?.value || "",
          dose5?.value || "",
        ])*/,
        timing: timing?.value || "",
        continueTill: continueTill?.value || "",
        indication: indication?.value || "",
      });
      // Clear form
      setSelectedMedicine(null);
      setDose(null);
      setIndication(null);
      setDose1(null);
      setDose2(null);
      setDose3(null);
      setDose4(null);
      setDose5(null);
      setTiming(null);
      setContinueTill(null);
    }
  };

  const getMedicineDosage = (stringDosage) => {
    let medicineDosage = stringDosage[0];
    let Tab = true;

    for (let i = 1; i < stringDosage.length; i++) {
      const val = stringDosage[i];
      const num = parseFloat(val);

      if (!isNaN(num) && val.trim() !== "") {
        medicineDosage += Tab ? "+" + val : " " + val;
      } else if (val.trim() !== "") {
        medicineDosage += " " + val;
        Tab = false;
      }
    }

    return medicineDosage;
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div className="flex items-center space-x-2 mb-6">
        <Pill className="text-purple-600" size={20} />
        <p className="text-lg font-semibold text-gray-800">Add Medicine</p>
      </div>

      {/* Add Medicine Form */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <CustomSelect
          options={medicineOptions}
          value={selectedMedicine}
          onChange={setSelectedMedicine}
          placeholder="Medicine..."
          className="sm:col-span-2 lg:col-span-1"
        />
        {/*
        <CustomSelect
          options={dose1Options}
          value={dose1}
          onChange={setDose1}
          placeholder="Dose 1..."
        />
        <CustomSelect
          options={dose2Options}
          value={dose2}
          onChange={setDose2}
          placeholder="Dose 2..."
        />
        <CustomSelect
          options={dose3Options}
          value={dose3}
          onChange={setDose3}
          placeholder="Dose 3..."
        />
        <CustomSelect
          options={dose4Options}
          value={dose4}
          onChange={setDose4}
          placeholder="Dose 4..."
        />
        <CustomSelect
          options={dose5Options}
          value={dose5}
          onChange={setDose5}
          placeholder="Dose 5..."
        />
        */}
        <input
          type="text"
          value={dose?.value || ""}
          onChange={(e) => setDose({ value: e.target.value, label: e.target.value })}
          placeholder="Dosage..."
          className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent w-full"
        />
        <CustomSelect
          options={timingOptions}
          value={timing}
          onChange={setTiming}
          placeholder="Timing..."
        />
        <CustomSelect
          options={continueOptions}
          value={continueTill}
          onChange={setContinueTill}
          placeholder="Duration..."
        />
        <input
          type="text"
          value={indication?.value || ""}
          onChange={(e) => setIndication({ value: e.target.value, label: e.target.value })}
          placeholder="Indication..."
          className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent w-full"
        />
      </div>

      <button
        onClick={handleAdd}
        disabled={!selectedMedicine || !dose || !timing || !continueTill || !indication}
        className="px-6 py-3 bg-green-600 text-white font-medium rounded-lg shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
      >
        <Plus size={18} className="inline mr-2" />
        Add Medicine
      </button>
    </div>
  );
};

export default MedicineSelector;
